<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>

    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">
        {{ operacion() }}
        {{ (id_perfil() == 1 || id_perfil() == 3 || id_perfil() == 4) ? 'Ubicación' : 'Dirección' }}
      </h1>
    </div>
  </div>

  <div class="row-cols-12 m-2 mt-0">
    <div class="row p-3 mb-0 align-items-center">
      <div class="mb-3 mt-0 text-start">
        <form
          (ngSubmit)="saveUbicacion()"
          (keydown.enter)="$event.preventDefault()"
          [formGroup]="myAccountUbicacion"
        >
          <div class="mb-4 mt-2 text-start">
            <label for="domicilio" class="form-label"><b>Domicilio</b></label>
            <input type="text" class="form-control" #inputPlaces id="inputPlaces" formControlName="domicilio" />

            @if (myAccountUbicacion.controls['domicilio'].invalid
              && (myAccountUbicacion.controls['domicilio'].dirty || myAccountUbicacion.controls['domicilio'].touched)
              && myAccountUbicacion.controls['domicilio'].errors?.['required']) {
              <div class="alert-danger" role="alert">
                <small class="alert">El domicilio es requerido</small>
              </div>
            }
          </div>

          <div class="row mb-4 mt-0 text-start">
            <div class="col col-sm-4">
              <label for="piso_dpto" class="form-label"><b>Piso / Depto</b></label>
              <input type="text" class="form-control" id="piso_dpto" formControlName="piso_dpto" placeholder="Ingrese un Piso / Depto" />
            </div>

            <div class="col col-sm-4">
              <label for="codigo_postal" class="form-label"><b>C.P.</b></label>
              <input type="text" class="form-control" id="codigo_postal" formControlName="codigo_postal" placeholder="Ingrese un C.P." />
            </div>

            @if (myAccountUbicacion.controls['codigo_postal'].invalid
              && (myAccountUbicacion.controls['codigo_postal'].dirty || myAccountUbicacion.controls['codigo_postal'].touched)
              && myAccountUbicacion.controls['codigo_postal'].errors?.['required']) {
              <div class="alert-danger" role="alert">
                <small class="alert">Ingrese un Código Postal</small>
              </div>
            }
          </div>

          <div class="mapa-wrapper position-relative">
            <!-- Spinner overlay -->
            @if (loading()) {
              <div class="spinner-overlay fade-in">
                <div class="spinner-border text-info color-spinner" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            }

            <!-- Mapa -->
            <div class="row mb-4 mt-0 text-start">
              <div class="mapa" #divMap id="map" [class.mapa-opaco]="loading()"></div>
            </div>
          </div>

          <div class="mb-4 mt-2 text-start">
            <label for="telefono" class="form-label"><b>Teléfono</b></label>
            <input type="text" inputmode="numeric" class="form-control" id="telefono" formControlName="telefono" placeholder="Ingrese un teléfono" (input)="soloNumeros('telefono', $event)" />

            @if (myAccountUbicacion.controls['telefono'].invalid
              && (myAccountUbicacion.controls['telefono'].dirty || myAccountUbicacion.controls['telefono'].touched)
              && myAccountUbicacion.controls['telefono'].errors?.['required']) {
              <div class="alert-danger" role="alert">
                <small class="alert">El teléfono es requerido</small>
              </div>
            }
          </div>

          <div [hidden]="error().length == 0" class="alert alert-danger mt-2" role="alert">
            <small>{{ error() }}</small>
          </div>

          <div class="d-grid mt-5 mb-3 pb-3">
            <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">
              {{ loading() ? 'Cargando...' : botonOperacion() }}
              {{ (id_perfil() == 1 || id_perfil() == 3 || id_perfil() == 4) ? 'Ubicación' : 'Dirección' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
